import { InjectionToken } from '@angular/core';

export const MODAL_MANAGER_CONFIG = new InjectionToken<IModalManagerConfig>('MODAL_MANAGER_CONFIG');

export interface IModalManagerConfig {
  /**
   * This flag is needed for use hash keys when opening modal window.
   * @default false
   */
  isUseHash: boolean;
}
